export default __webpack_public_path__ + "static/media/colbs.37e48466.gif";